import React, { useEffect, useState } from 'react'
import { sortData } from '../../utils';
import Popup from 'reactjs-popup';
import { HalfCircleSpinner } from 'react-epic-spinners';
import { toast } from 'react-toastify';
import { useAuth } from '../../api/services/auth';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import bookmarkCasee from "../../api/services/bookmarkCase";
import CaseSearch from '../case-listing/caseSearch';
import { userPermissions, userRoles } from '../../enums';
import Pagination from '../pagination';
import { deleteCase } from '../../api/services/cases';
import caseListing from '../../api/services/caseListing';
import CurrentCaseDirectoryRow from '../caseItemRow/currentCaseDirectoryRow';
import UpcomingCaseDirectoryRow from '../caseItemRow/upcomingCaseDirectoryRow';

function Directory() {
    const location = useLocation()
    const [active, setActive] = useState(location?.state?.upcoming ? true : false);
    const [currentCases, setCurrentCases] = useState([]);
    const [upcommingCases, setUpcommingCases] = useState([]);
    const [selectedCaseBookmark, setSelectedCaseBookmark] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const [selectedCaseId, setSelectedCaseId] = useState(null);
    const [publishedLoading, setPublishedLoading] = useState(true);
    const [upcomingLoading, setUpcomingLoading] = useState(true);
    const [bookmarkCaseType, setBookmarkCaseType] = useState('')
    const [filteredSearch, setFilteredSearch] = useState(false)
    const [showFilters, setShowFilters] = useState(false);
    const [pagination, setPagination] = useState({});
    const [upcommingPagination, setUpcommingPagination] = useState({});
    const [deleteId, setDeleteId] = useState(null)
    const [upcomingdeleteId, setupcomingDeleteId] = useState(null)
    const [formData, setFormData] = useState({
        comorbidity_id: '',
        complication_id: '',
        procedure_id: '',
        consultant_id: '',
        flag_status: '',
        reference: '',
        procedure_date: '',
        state: 'all'
    });
    const [publishedSorting, setPublishedSorting] = useState({
        column: null,
        order: 'asc'
    });
    const [upcommingSorting, setUpcommingSorting] = useState({
        column: null,
        order: 'asc'
    });

    // Get_Current_Cases_Listing
    useEffect(() => {
        caseListing.getCases(1, { status: 'current' })
            .then((res) => {
                setPublishedLoading(false)
                setCurrentCases(res.data.map(item => ({
                    ...item,
                    status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                })));
                setPagination({ ...res.meta });
            }
            ).catch(error => {
                setPublishedLoading(false)
                console.error('Error fetching data:', error)
            });

        caseListing.getCases(1, { status: 'upcoming' })
            .then((res) => {
                setUpcommingCases(res.data.map(item => ({
                    ...item,
                    status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                })));
                setUpcommingPagination({ ...res.meta });
                setUpcomingLoading(false)
            }
            ).catch(error => {
                setUpcomingLoading(false)
                console.error('Error fetching data:', error)
            });
    }, []);

    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Smooth scrolling behavior
        });
    };

    // Handle_Bookmark_Click
    const handleBookmarkCaseClick = (caseId, bookmark, caseType) => {
        setBookmarkCaseType(caseType)
        setSelectedCaseBookmark(bookmark);
        setSelectedCaseId(caseId);
        if (bookmark === 0) {
            setSelectedCaseBookmark(1);
        } else {
            setSelectedCaseBookmark(0);
        }
    };

    // Handle_Bookmark_Case
    const handleBookmarkCase = () => {
        setShowLoader(true);

        let caseId = selectedCaseId;
        let bookmark = selectedCaseBookmark;

        const requestBody = {
            bookmark: bookmark,
        };

        bookmarkCasee.bookmark(caseId, requestBody)
            .then((res) => {
                setShowLoader(false);
                toast.success(res.message);
                if (bookmarkCaseType === 'current') {
                    caseListing.getCases(1, { status: 'current' })
                        .then((res) => {
                            setCurrentCases(res.data);
                            setPagination({ ...res.meta });
                        }
                        ).catch(error => {
                            console.error('Error fetching data:', error)
                        });

                } else if (bookmarkCaseType === 'upcomming') {
                    caseListing.getCases(1, { status: 'upcoming' })
                        .then((res) => {
                            setUpcommingCases(res.data);
                            setUpcommingPagination({ ...res.meta });
                        }
                        ).catch(error => {
                            console.error('Error fetching data:', error)
                        });
                }
            }
            ).catch((error) => {
                setShowLoader(false);
                toast.error(error.data.message);
            }
            );
        setSelectedCaseId(null);
        setSelectedCaseBookmark(null);
        setBookmarkCaseType('')
    };

    // Handle_Sort_Table_Data
    const handlePublishedSort = (columnName) => {
        setPublishedSorting((prevSorting) => ({
            column: columnName,
            order: prevSorting.column === columnName && prevSorting.order === 'asc' ? 'desc' : 'asc',
        }));

        // Sort the data based on the selected column and order
        const sortedData = sortData(currentCases, publishedSorting, setPublishedSorting, columnName, publishedSorting.order);
        setCurrentCases(sortedData);
    };

    const isPublishedColumnSorted = (columnName) => {
        return publishedSorting.column === columnName;
    };

    // Hadle_Page_Click
    const handlePageClick = (pageNo) => {
        caseListing.getCases(pageNo, { status: 'current' })
            .then((res) => {
                handleScrollToTop()
                setPublishedLoading(false)
                setCurrentCases(res.data);
                setPagination({ ...res.meta });
                setPublishedSorting({
                    column: null,
                    order: 'asc'
                });
            }
            ).catch(error => {
                setPublishedLoading(false)
                console.error('Error fetching data:', error)
            });
    };

    // Hadle_Page_Click
    const handleUpcommingPageClick = (pageNo) => {
        caseListing.getCases(pageNo, { status: 'upcoming' })
            .then((res) => {
                handleScrollToTop()
                setUpcommingCases(res.data);
                setUpcommingPagination({ ...res.meta });
                setUpcomingLoading(false)
                setUpcommingSorting({
                    column: null,
                    order: 'asc'
                });
            }
            ).catch(error => {
                setUpcomingLoading(false)
                console.error('Error fetching data:', error)
            });
    };

    // Handle_Sort_Table_Data
    const handleUpcommingSort = (columnName) => {
        setUpcommingSorting((prevSorting) => ({
            column: columnName,
            order: prevSorting.column === columnName && prevSorting.order === 'asc' ? 'desc' : 'asc',
        }));

        // Sort the data based on the selected column and order
        const sortedData = sortData(upcommingCases, upcommingSorting, setUpcommingSorting, columnName, upcommingSorting.order);
        setUpcommingCases(sortedData);
    };

    const isUpcommingColumnSorted = (columnName) => {
        return upcommingSorting.column === columnName;
    };

    const handleSwitch = (status) => {
        setShowFilters(false);
        setPublishedSorting({
            column: null,
            order: 'asc'
        })
        setUpcommingSorting({
            column: null,
            order: 'asc'
        })
        setFormData({
            comorbidity_id: '',
            complication_id: '',
            procedure_id: '',
            consultant_id: '',
            flag_status: '',
            state: "all"
        })
        if (status !== 'active') {
            setActive(false)
            caseListing.getCases(1, { status: 'current' })
                .then((res) => {
                    setPublishedLoading(false)
                    setCurrentCases(res.data.map(item => ({
                        ...item,
                        status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                    })));
                    setPagination({ ...res.meta });
                }
                ).catch(error => {
                    setPublishedLoading(false)
                    console.error('Error fetching data:', error)
                });

        } else {
            setActive(true)
            caseListing.getCases(1, { status: 'upcoming' })
                .then((res) => {
                    setUpcommingCases(res.data.map(item => ({
                        ...item,
                        status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                    })));
                    setUpcommingPagination({ ...res.meta });
                    setUpcomingLoading(false)
                }
                ).catch(error => {
                    setUpcomingLoading(false)
                    console.error('Error fetching data:', error)
                });
        }
    }

    // Handle_Delete_CASE
    const handlCurrentDeleteCase = () => {
        deleteCase.delete(deleteId)
            .then((res) => {
                toast.success(res.message);
                caseListing.getCases(1, { status: 'current' })
                    .then((res) => {
                        setPublishedLoading(false)
                        setDeleteId(null)
                        setupcomingDeleteId(null)
                        setCurrentCases(res.data.map(item => ({
                            ...item,
                            status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                        })));
                        setPagination({ ...res.meta });
                    }
                    ).catch(error => {
                        setPublishedLoading(false)
                        console.error('Error fetching data:', error)
                    });

            }
            ).catch((error) => {
                setDeleteId(null)
                setupcomingDeleteId(null)
                toast.error(error.data.message);
            });
    };

    const handlUpcomingDeleteCase = () => {
        deleteCase.delete(upcomingdeleteId)
            .then((res) => {
                toast.success(res.message);
                caseListing.getCases(1, { status: 'upcoming' })
                    .then((res) => {
                        setUpcommingCases(res.data.map(item => ({
                            ...item,
                            status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                        })));
                        setUpcommingPagination({ ...res.meta });
                        setUpcomingLoading(false)
                        setDeleteId(null)
                        setupcomingDeleteId(null)
                    }
                    ).catch(error => {
                        setUpcomingLoading(false)
                        console.error('Error fetching data:', error)
                    });

            }
            ).catch((error) => {
                setDeleteId(null)
                setupcomingDeleteId(null)
                toast.error(error.data.message);
            });
    };

    const handleCurrentFilter = (e) => {
        const state = e.target.value;
        setFormData({ ...formData, state })
        caseListing.getCases(1, { ...formData, status: 'current', state })
            .then((res) => {
                setCurrentCases(res.data.map(item => ({
                    ...item,
                    status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                })));
                setPagination(res.meta);
            }
            ).catch(error => {
                console.error('Error fetching data:', error)
            });
    }

    const handleUpcomingFilter = (e) => {
        const state = e.target.value;
        setFormData({ ...formData, state })
        caseListing.getCases(1, { ...formData, status: 'upcoming', state })
            .then((res) => {
                setUpcommingCases(res.data.map(item => ({
                    ...item,
                    status: item && item.status ? item.status.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : "-"
                })));
                setUpcommingPagination(res.meta);
            }
            ).catch(error => {
                console.error('Error fetching data:', error)
            });
    }

    return (
        <div>
            <div className="dbContentWrap">
                {showFilters && <CaseSearch
                    setFilteredSearch={setFilteredSearch}
                    setLoading={!active ? setPublishedLoading : setUpcomingLoading}
                    caseCall={!active ? 'publishedCase' : 'upcomingCase'}
                    setShowFilters={setShowFilters}
                    setCasesList={!active ? setCurrentCases : setUpcommingCases}
                    formData={formData}
                    setFormData={setFormData}
                    setPagination={!active ? setPagination : setUpcommingPagination}
                />}
                <div className="tableWidget">
                    <ul className="navTabs listUnstyled">
                        <li onClick={() => {
                            handleSwitch('inActive')

                        }} className={!active ? "active" : ""}><a>Current Cases (Post Op)</a></li>
                        <li onClick={() => {
                            handleSwitch('active')

                        }} className={active ? "active" : ""}><a >Upcoming Cases (Pre-Op)</a></li>
                    </ul>
                    <div className="tabsContentWrap">
                        {!active && (
                            <div id="tab1" className="tabContent">
                                <article className="widgetWrap">
                                    <div className="widgetHeader">
                                        <span>Group Cases  <div className="selectWrap posRelative caseFilters">
                                            <select onChange={handleCurrentFilter} name="cases" className="widgetSelect">
                                                <option value="all">All</option>
                                                <option value="1">One Week</option>
                                                <option value="2">Two Weeks</option>
                                            </select>
                                        </div></span>
                                        <div className="tabHeadActionWrap">
                                            <button onClick={() => {
                                                setShowFilters(true);
                                            }} type="button" className={`actionBtn ${showFilters && 'active'}`}>Search Filter <i className="fa-solid fa-filter"></i></button>
                                        </div>
                                    </div>
                                    <div className="tableWrap">
                                        <table className="table fontSmall textCenter w100">
                                            <thead>
                                                <tr>
                                                    <th
                                                        className={`sortable ${isPublishedColumnSorted('reference') ? ' sorted' : ''}`}
                                                        onClick={() => handlePublishedSort('reference')}
                                                    >Ref <i className="icn fa-solid fa-caret-down"></i></th>
                                                    <th
                                                        className={`sortable ${isPublishedColumnSorted('procedure_date') ? ' sorted' : ''}`}
                                                        onClick={() => handlePublishedSort('procedure_date')}
                                                    >Date <i className="icn fa-solid fa-caret-down"></i></th>
                                                    <th>Consultant <i className="fa-solid fa-magnifying-glass"></i></th>
                                                    <th>Procedure <i className="fa-solid fa-magnifying-glass"></i></th>
                                                    <th>Comorbidities <i className="fa-solid fa-magnifying-glass"></i></th>
                                                    <th>Complications <i className="fa-solid fa-magnifying-glass"></i></th>
                                                    <th
                                                        className={`sortable ${isPublishedColumnSorted('status') ? ' sorted' : ''}`}
                                                        onClick={() => handlePublishedSort('status')}
                                                    >Status <i className="icn fa-solid fa-caret-down"></i></th>
                                                    <th className="thComments">Comments</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(currentCases && (currentCases?.length > 0)) ? currentCases.map((data) => (
                                                    <CurrentCaseDirectoryRow
                                                        data={data}
                                                        handleBookmarkCaseClick={handleBookmarkCaseClick}
                                                        setCurrentCases={setCurrentCases}
                                                        setDeleteId={setDeleteId}
                                                    />
                                                )) : publishedLoading ?
                                                    <tr>
                                                        <td colSpan={9}><HalfCircleSpinner
                                                            size={18}
                                                            color='black'
                                                            style={{
                                                                display: "inline-block",
                                                                marginLeft: "7px",
                                                                position: "relative",
                                                                top: "2px",
                                                            }}
                                                        /></td>
                                                    </tr> :
                                                    <tr>
                                                        <td colSpan={9}>No record found</td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <div className="widgetFooter">
                                        <div className="textCenter">
                                            <Link to="/published-cases">View More</Link>
                                        </div>
                                    </div> */}
                                    <div className="widgetFooter">
                                        <div className="textCenter">
                                            {pagination && (Object.keys(pagination)?.length > 0) && (
                                                <Pagination pagination={pagination} handlePageClick={handlePageClick} />
                                            )}
                                        </div>
                                    </div>
                                </article>
                            </div>
                        )}
                        {active && (
                            <div id="tab2" className="tabContent">
                                <article className="widgetWrap">
                                    <div className="widgetHeader">
                                        <span>Group Cases  <div className="selectWrap posRelative caseFilters">
                                            <select onChange={handleUpcomingFilter} name="cases" className="widgetSelect">
                                                <option value="all">All</option>
                                                <option value="1">One Week</option>
                                                <option value="2">Two Weeks</option>
                                            </select>
                                        </div></span>
                                        <div className="tabHeadActionWrap">
                                            <button onClick={() => {
                                                setShowFilters(true);
                                            }} type="button" className={`actionBtn ${showFilters && 'active'}`}>Search Filter <i className="fa-solid fa-filter"></i></button>
                                        </div>
                                    </div>
                                    <div className="tableWrap">
                                        <table className="table fontSmall textCenter w100">
                                            <thead>
                                                <tr>
                                                    <th className={`sortable ${isUpcommingColumnSorted('reference') ? ' sorted' : ''}`}
                                                        onClick={() => handleUpcommingSort('reference')}>Ref <i className="icn fa-solid fa-caret-down"></i></th>
                                                    <th
                                                        className={`sortable ${isUpcommingColumnSorted('procedure_date') ? ' sorted' : ''}`}
                                                        onClick={() => handleUpcommingSort('procedure_date')}
                                                    >Date <i className="icn fa-solid fa-caret-down"></i></th>
                                                    <th>Consultant <i className="fa-solid fa-magnifying-glass"></i></th>
                                                    <th>Procedure <i className="fa-solid fa-magnifying-glass"></i></th>
                                                    <th>Comorbidities <i className="fa-solid fa-magnifying-glass"></i></th>
                                                    <th>Complications <i className="fa-solid fa-magnifying-glass"></i></th>
                                                    <th
                                                        className={`sortable ${isUpcommingColumnSorted('status') ? ' sorted' : ''}`}
                                                        onClick={() => handleUpcommingSort('status')}
                                                    >Status <i className="icn fa-solid fa-caret-down"></i></th>
                                                    <th className="thComments">Comments</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(upcommingCases && (upcommingCases?.length > 0)) ? upcommingCases.map((data) => (
                                                    <UpcomingCaseDirectoryRow
                                                        data={data}
                                                        handleBookmarkCaseClick={handleBookmarkCaseClick}
                                                        setUpcommingCases={setUpcommingCases}
                                                        setupcomingDeleteId={setupcomingDeleteId}
                                                    />
                                                )) : upcomingLoading ?
                                                    <tr>
                                                        <td colSpan={9}><HalfCircleSpinner
                                                            size={18}
                                                            color='black'
                                                            style={{
                                                                display: "inline-block",
                                                                marginLeft: "7px",
                                                                position: "relative",
                                                                top: "2px",
                                                            }}
                                                        /></td>
                                                    </tr> :
                                                    <tr>
                                                        <td colSpan={9}>No record found</td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="widgetFooter">
                                        <div className="textCenter">
                                            {upcommingPagination && (Object.keys(upcommingPagination)?.length > 0) && (
                                                <Pagination pagination={upcommingPagination} handlePageClick={handleUpcommingPageClick} />
                                            )}
                                        </div>
                                    </div>
                                    {/* <div className="widgetFooter">
                                        <div className="textCenter">
                                            <Link to="/upcoming-cases">View More</Link>
                                        </div>
                                    </div> */}
                                </article>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Bookmark_Case_Popup */}
            <Popup
                className="deleteUserModal"
                open={selectedCaseId !== null && selectedCaseBookmark !== null}
                onClose={() => {
                    setSelectedCaseId(null)
                    setSelectedCaseBookmark(null)
                }}
            >
                {selectedCaseId !== null && (
                    <div className="modal textCenter">
                        <p>Are you sure you want to {selectedCaseBookmark === 0 ? 'close bookmark on' : 'bookmark'}  this case?</p>
                        <div className="btnWrap">
                            <button
                                onClick={() => {
                                    setSelectedCaseId(null)
                                    setSelectedCaseBookmark(null)
                                    setBookmarkCaseType('')
                                }}
                                type="button"
                                className="btn btnSecondary"
                            >Cancel</button>
                            <button
                                onClick={handleBookmarkCase}
                                type="button"
                                className="btn btnPrimary"
                                disabled={showLoader}
                            >Confirm
                                {showLoader && (
                                    <HalfCircleSpinner
                                        size={18}
                                        style={{
                                            display: "inline-block",
                                            marginLeft: "7px",
                                            position: 'relative',
                                            top: '2px',
                                        }}
                                    />
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </Popup>


            {/* DELETE_Case_Popup */}
            <Popup
                className="deleteUserModal"
                open={deleteId !== null}
                onClose={() => {
                    setDeleteId(null)
                    setupcomingDeleteId(null)
                }}
            >
                {deleteId !== null && (
                    <div className="modal textCenter">
                        <p>Are you sure you want to Archive this case?</p>
                        <div className="btnWrap">
                            <button
                                onClick={() => {
                                    setDeleteId(null)
                                    setupcomingDeleteId(null)
                                }}
                                type="button"
                                className="btn btnSecondary"
                            >No</button>
                            <button
                                onClick={handlCurrentDeleteCase}
                                type="button"
                                className="btn btnPrimary"
                                disabled={showLoader}
                            >Yes
                                {showLoader && (
                                    <HalfCircleSpinner
                                        size={18}
                                        style={{
                                            display: "inline-block",
                                            marginLeft: "7px",
                                            position: 'relative',
                                            top: '2px',
                                        }}
                                    />
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </Popup>

            {/* DELETE_Upcoming_Case_Popup */}
            <Popup
                className="deleteUserModal"
                open={upcomingdeleteId !== null}
                onClose={() => {
                    setDeleteId(null)
                    setupcomingDeleteId(null)
                }}
            >
                {upcomingdeleteId !== null && (
                    <div className="modal textCenter">
                        <p>Are you sure you want to Archive this case?</p>
                        <div className="btnWrap">
                            <button
                                onClick={() => {
                                    setDeleteId(null)
                                    setupcomingDeleteId(null)
                                }}
                                type="button"
                                className="btn btnSecondary"
                            >No</button>
                            <button
                                onClick={handlUpcomingDeleteCase}
                                type="button"
                                className="btn btnPrimary"
                                disabled={showLoader}
                            >Yes
                                {showLoader && (
                                    <HalfCircleSpinner
                                        size={18}
                                        style={{
                                            display: "inline-block",
                                            marginLeft: "7px",
                                            position: 'relative',
                                            top: '2px',
                                        }}
                                    />
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </Popup>
        </div>
    )
}

export default Directory